import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from '../components/DropdownButton';
import { ReactComponent as ClientIcon } from '../assets/images/client-view.svg';
import { ReactComponent as UserIcon } from '../assets/images/user-view.svg';
import { mySitesAvailable, defaultWOView } from '../helpers';
import ClientSelect from './ClientSelect';
import useDashboardStore from '../pages/dashboard/store/DashboardStore';
import { getUserData } from '../_actions';

const SubHeader = ({ path }) => {
  const [
    { clientView, selectedClient },
    { toggleView, toggleWOView, setClient }
  ] = useDashboardStore();

  const checkVisibility = () => {
    return clientView ? (
      <ClientIcon className="d-inline-flex" />
    ) : (
      <UserIcon className="d-inline-flex" />
    );
  };

  const views = [
    { id: 1, name: 'User view', icon: <UserIcon className="d-inline-flex" /> },
    { id: 2, name: 'Client view', icon: <ClientIcon className="d-inline-flex" /> }
  ];

  const disableViewToggle = useMemo(() => !mySitesAvailable(), []);

  const handleSelect = (type, view) => {
    if (type === 'dashboard') {
      const isClientView = view === 'Client view';
      toggleView(isClientView);
      if (!isClientView && !selectedClient?.assigned) {
        setClient(null);
      }
      return;
    }
    toggleWOView(view);
  };

  useEffect(() => {
    const userObj = getUserData();
    if (userObj.roles_name) {
      handleSelect('workorder', defaultWOView());
    }
  }, []);

  return (
    <div className="header-elements-md-inline py-16">
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex align-items-center col-md-8 px-0 gap-16">
          <h1 className="sub-header-page-title mb-0">{path}</h1>
          <div className="list-icons">
            <DropdownButton
              className="btn mode-select"
              title={checkVisibility()}
              disabled={disableViewToggle}
            >
              {views?.map(view => (
                <button
                  key={view.name}
                  type="button"
                  className="dropdown-item"
                  onClick={() => handleSelect('dashboard', view.name)}
                >
                  {view.icon}
                  {view.name}
                </button>
              ))}
            </DropdownButton>
          </div>
          <ClientSelect />
        </div>
      </div>
    </div>
  );
};

SubHeader.propTypes = {
  path: PropTypes.string.isRequired
};

export default SubHeader;
